var map = {
	"./album-logo.png": 58414,
	"./playlist-th.svg": 61949,
	"./playlist-zh.svg": 54971,
	"./playlist.png": 21584,
	"./preview-video.jpg": 61242,
	"./registration.png": 93605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9148;